// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rrO2","colMin":"styles_colMin__21PjK"};